import { render, staticRenderFns } from "./studentGroupOrderForm.vue?vue&type=template&id=74591724&"
import script from "./studentGroupOrderForm.vue?vue&type=script&lang=js&"
export * from "./studentGroupOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports